import fetchApi from "../fetch-api";
import { getQueryPath } from "ui-io/get-query-path";
import { MegaDealCompaniesIO } from "../deal-io";

type CompanyByIdPropsT = {
  date?: string;
  industry?: string;
  limit?: number;
};

export const getTopMegaDeal = (props: CompanyByIdPropsT) => {
  let params = props;
  const { industry, date } = props;
  const queryPath = getQueryPath({ ...params });
  return {
    queryKey: ["TOP_MEGA_DEAL_COMPANY", queryPath],
    queryFn: () =>
      fetchApi({
        service: "core-service",
        headers: { method: "GET" },
        pathname: `/top-mega-deal?${queryPath}`,
        codec: MegaDealCompaniesIO,
      }),
  };
};
